<template>
  <div>
    <teleport to="body">
      <div class="toast-list">
        <TransitionGroup name="list">
          <div class="toast" v-for="toast in toastList" :key="toast.id" :class="['toast-' + toast.options.color, { clickable: toast.options.click != null }]" @click="toastClicked(toast)">
            <div class="toast-body">
              <div class="d-flex align-items-center justify-content-between">
                <span>{{ toast.options.content }}</span>
                <button class="toast-dismiss" @click="toast.remove()">
                  <i class="fas fa-xmark" style="font-size: 2em"></i>
                </button>
              </div>
            </div>
          </div>
        </TransitionGroup>
      </div>
    </teleport>
  </div>
</template>

<script setup>
import toasts from "./toasts.js";
import {computed, onMounted, onUnmounted} from "vue";

onMounted(() => {
  setInterval(toasts.timer, 1000);
});

onUnmounted(() => {
  clearInterval(toasts.timer)
});

const toastList = computed(() => {
  return toasts.data.toasts;
});

function toastClicked(toast) {
  if (toast.options.click) {
    toast.options.click();
  }
  toast.remove();
}

</script>

<style scoped>
  .list-enter-active {
    transition: all .15s ease;
  }
  .list-leave-active {
    transition: all .08s ease;
  }
  .list-enter-from {
    opacity: 0;
    transform: translateY(100%);
  }
  .list-leave-to {
    opacity: 0;
    transform: translateX(100%);
  }
  .list-move {
    transition: transform .15s ease;
  }
</style>
